import { render } from "./editorView.vue?vue&type=template&id=185c5978&scoped=true"
import script from "./editorView.vue?vue&type=script&lang=js"
export * from "./editorView.vue?vue&type=script&lang=js"

import "./editorView.vue?vue&type=style&index=0&id=185c5978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185c5978"]])

export default __exports__